@if (!isError()) {
    <div class="form-group mb-10" [class.has-error]="!isLoading() && this.pipelineForm.pipeline().invalid()">
        <label>
            {{ "crm_deal_pipeline_and_state" | translate }}
        </label>
        <div class="p-relative" [class.block-loading]="isLoading()" dropdown>
            <div class="form-control funnel-control" dropdownToggle>
                <div class="funnel-avatar-name" style="background-color: #a3a2e0">
                    <span style="color: #fff">
                        {{ pipelineNameFirstLetter | uppercase }}
                    </span>
                </div>
                <div class="funnel-info">
                    <span class="funnel-name">
                        {{ pipelineName | translate }}
                    </span>
                    <div class="funnel-tag">
                        <span [style.background-color]="pipelineForm.step().value()?.color" style="color: #000">
                            {{ pipelineStepName | translate }}
                        </span>
                    </div>
                </div>
            </div>

            <ul class="dropdown-menu funnel-dropdown" *dropdownMenu>
                @for (crmPipeline of crmPipelines(); track crmPipeline.id) {
                    <li>
                        <div class="funnel-heading">
                            <div class="funnel-avatar-name" style="background-color: #a3a2e0">
                                <span style="color: #fff">{{ crmPipeline.name[0] | uppercase }}</span>
                            </div>
                            <span class="funnel-name">{{ crmPipeline.name | translate }}</span>
                        </div>
                        <ul class="funnel-tag">
                            @for (step of crmPipeline.steps; track step.id) {
                                <li
                                    (click)="
                                        setPipeline({ pipeline: crmPipeline, step, settings: crmPipeline.settings })
                                    "
                                >
                                    <span [style.background-color]="step.color">
                                        {{ step.name | translate }}
                                    </span>
                                </li>
                            }
                        </ul>
                    </li>
                }
            </ul>
        </div>
        @if (!isLoading() && this.pipelineForm.pipeline().invalid()) {
            <span class="help-block small">
                {{ "control_errors_required" | translate }}
            </span>
        }
    </div>
} @else {
    <div class="alert alert-danger">
        {{ "unknown_error" | translate }}
    </div>
}
